import { gql } from '@apollo/client/core';

export const CREATE_AVAILABILITY = gql`
  mutation ($start: DateTime!, $end: DateTime!, $kind: AvailabilityKind!) {
    createAvailability(start: $start, end: $end, kind: $kind)
  }
`;

export const CREATE_REPEATING_AVAILABILITY = gql`
  mutation ($start: DateTime!, $end: DateTime!, $schedule: RepeatingAvailabilitySchedule!) {
    createRepeatingAvailability(start: $start, end: $end, schedule: $schedule) {
      id
    }
  }
`;

export const CLEAR_AVAILABILITY = gql`
  mutation ($start: DateTime!, $end: DateTime!) {
    clearAvailability(start: $start, end: $end)
  }
`;

export const UPDATE_AVAILABILITY = gql`
  mutation ($clearStart: DateTime!, $clearEnd: DateTime!, $start: DateTime!, $end: DateTime!, $kind: AvailabilityKind!) {
    clearAvailability(start: $clearStart, end: $clearEnd)
    createAvailability(start: $start, end: $end, kind: $kind)
  }
`;
